export default __webpack_public_path__ + "static/media/line-mobile.a233317b.svg";